import * as React from 'react';
import { HashRouter as Router, Route, Redirect, Switch } from 'react-router-dom';

import Navigation from './components/Navigation';
import RequestService from './components/RequestService';
import RequestQuoteWizard from './components/RequestQuote';

import Banner from '../../components/Banner';
import Layout from '../../components/Layout';
import FormErrorSummary from '../../components/Form/Fields/FormErrorSummary';

import { SolarContactState, SolarContactProps } from './SolarContact.types';
import analytics from '../../analytics';

class SolarContact extends React.Component<SolarContactProps, SolarContactState> {
  constructor(props: SolarContactProps) {
    super(props);

    this.state = {
      view: 'request',
      graphError: false,
      graphMessage: 'Sorry, something went wrong. Please try again.'
    };

    this.selectForm = this.selectForm.bind(this);
    this.onGraphError = this.onGraphError.bind(this);
  }

  componentWillMount() {
    if (window.location.hash) {
      if (
        window.location.hash === '#/contact/general-enquiry' ||
        window.location.hash === '#/contact/customer-enquiry'
      ) {
        this.selectForm('general');
      }
    }
  }

  onGraphError(value: boolean, errorMessage: string | undefined): void {
    if (value) window.scrollTo(0, 0);

    this.setState({
      graphError: value,
      graphMessage: errorMessage || 'Sorry, something went wrong. Please try again.'
    });

    if (value) analytics.error(this.state.graphMessage);
  }

  selectForm(view: string): void {
    const { history, match } = this.props;
    const path = view === 'request' ? 'request-a-quote' : 'general-enquiry';

    history.push(`${match.url}/${path}`);
    analytics.appName = `solar-${path}`;
    this.setState({
      view,
      graphError: false
    });
  }

  render(): JSX.Element {
    const { view, graphError, graphMessage } = this.state;
    const { match } = this.props;

    return (
      <React.Fragment>
        <Banner
          title={'Contact our solar experts'}
          subtitle={
            "For new solar panels, inverters and batteries, and for any maintenance needs. We'll look after you for the life of your system."
          }
        />
        <Layout min={['SM', 'MD']} max={[]} paddingX={4}>
          <FormErrorSummary graphError={graphError} graphMessage={graphMessage} />
          <Navigation view={view} onChange={this.selectForm.bind(this)} />

          <Router>
            <Switch>
              <Redirect exact from={match.url} to={`${match.url}/request-a-quote`} />
              <Route
                exact
                path={`${match.url}/request-a-quote`}
                render={(props): JSX.Element => (
                  <RequestQuoteWizard
                    {...props}
                    onGraphError={this.onGraphError}
                    graphError={graphError}
                    graphMessage={graphMessage}
                  />
                )}
              />
              <Route
                exact
                path={`${match.url}/general-enquiry`}
                render={(props): JSX.Element => (
                  <RequestService
                    {...props}
                    onGraphError={this.onGraphError}
                    graphError={graphError}
                    graphMessage={graphMessage}
                  />
                )}
              />
            </Switch>
          </Router>
        </Layout>
      </React.Fragment>
    );
  }
}

export { SolarContact as default };
